<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-zxhuihua`]" width="1em" height="1em" v-bind="$attrs"><path d="M110,108 C112.761424,108 115,110.238576 115,113 C115,115.761424 112.761424,118 110,118 L22,118 C19.2385763,118 17,115.761424 17,113 C17,110.238576 19.2385763,108 22,108 L110,108 Z M115,11 C119.970563,11 124,15.0294373 124,20 L124,92 C124,96.9705627 119.970563,101 115,101 L15,101 C10.0294373,101 6,96.9705627 6,92 L6,20 C6,15.0294373 10.0294373,11 15,11 L115,11 Z M114,21 L16,21 L16,91 L114,91 L114,21 Z M63.6018386,39.0209143 L78.8524422,48.3308024 C87.0491859,53.3334718 87.0491859,63.6563865 78.8524422,68.6595198 C78.7888366,68.6595198 63.6018386,77.968944 63.6018386,77.968944 C55.214278,83.0983964 46,78.0323355 46,68.1528519 L46,48.8370065 C46,39.0209143 55.1505173,33.8914619 63.6018386,39.0209143 Z M53.435028,48.9003979 L53.435028,68.2162434 C53.3714224,72.2694322 56.2304161,73.7889722 59.7259311,71.6992182 L75.0395198,62.389794 C78.5978647,60.2366485 78.5978647,56.8164467 75.0395198,54.6633012 L59.7259311,45.3540316 C56.1674311,43.2008861 53.435028,44.8472091 53.435028,48.9003979 Z" :fill="useCurrentColor ? 'currentColor' : '#4E5969'" fill-rule="evenodd"/></svg>
</template>
<script>

export default {
  name: 'IconPsmZxhuihua',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
